/* global axios */
import ApiClient from '../ApiClient';

class ElectoralCampaignScriptsAPI extends ApiClient {
  constructor() {
    super('electoral_campaign/scripts', {
      accountScoped: true,
      apiVersion: 'v2',
    });
  }

  list({ eventType } = {}) {
    const params = {};
    if (eventType) params.eventType = eventType;
    return axios.get(this.url, { params });
  }

  create(payload) {
    return axios.post(this.url, payload);
  }
}

export default new ElectoralCampaignScriptsAPI();
